<!DOCTYPE html>
@if (fortuneMissionData$ |async; as mission) {
  <div class="missions-wrapper">
    <div class="page-title">
      <h2> {{ "missions.Missions" | translate }}</h2>
    </div>
    <div class="hero-card">
      <swiper #gameMission [config]="cardSlide" class="swiper-inbox" (swiper)="onSlideChange(mission?.restData)"
        (slideChange)="onSlideChange(mission?.restData)">
        @for (one of mission?.restData; track one) {
          <ng-template swiperSlide>
            <div class="slide-card  card-green"
              [ngClass]="checkCards(one) == 'joinWithDisable' ? 'card-disabled' : 'slide-card card-green'">
              <ion-grid>
                <ion-row>
                  <ion-col size="7" class="left-block">
                    <div [ngClass]="checkCards(one) == 'joinWithDisable' ? 'disable-title' : 'card-heading'" class="title">
                    {{one?.eventData?.content?.[selectedLanguage]?.title}}</div>
                    <div [ngClass]="checkCards(one) == 'joinWithDisable' ? 'disable-description' : 'card-heading'"
                      class="sub-title">{{one?.eventData?.content?.[selectedLanguage]?.description}}
                    </div>
                    <!-- buttons -->
                    @if (checkCards(one) == 'completed') {
                      <button class="card-btn completed-btn">
                        {{ "missions.Completed" | translate }}
                      </button>
                    }
                    @if (checkCards(one) == 'join' && !spinnerAnimation) {
                      <button
                        [ngClass]="getButtonText(one) == 'join' ? 'bg-v': 'card-btn box-shadow' " class="join-btn dis"
                        [disabled]="userAlreadyJoined" (click)="missionsDialog(); startSpinner()">
                        {{getButtonText(one)| async}}
                      </button>
                    }
                    @if (checkCards(one) == 'join' && spinnerAnimation  && getButtonText(mission?.restData?.[selectedCard])!='Join'  ) {
                      <div
                        [ngClass]="{ 'bg-v': checkCards(one) == 'join' }" class="join-btn ">
                        <mat-progress-spinner mode="determinate" [value]="progressBar" class="track-spinner" diameter="30">
                        </mat-progress-spinner>
                      </div>
                    }
                    @if (checkCards(one) == 'joinWithDisable') {
                      <button [disabled]="isDisable" class="join-btn"
                        (click)="missionsDialog()">
                        {{ "missions.Join" | translate }}
                      </button>
                    }
                    <!-- <button (click)="missionsDialog()">Join</button> -->
                  </ion-col>
                  <ion-col size="5" class="right-block">
                    <div class="float-right">
                      <!-- <span>  -->
                      @if (checkCards(one) == 'completed') {
                        <span class="timer green"> <img
                          src="../../../../../../assets/icon/greencup.svg" alt=""> {{
                        "missions.Complete!" | translate }}</span>
                      }
                      @if (checkCards(one) == 'join') {
                        <span class="timer green">
                          <img src="../../../../../../assets/icon/greencup.svg" alt=""> <app-count-down-timer
                          class="remaining-time" end="{{ one.end.seconds }}" type="seconds">
                        </app-count-down-timer></span>
                      }
                      @if (checkCards(one) == 'joinWithDisable') {
                        <span class="timer green"><img
                          src="../../../../../../assets/icon/greencup.svg" alt="">{{
                        "missions.Starts" | translate }} {{ getweeks(one?.start) }}</span>
                      }
                    <!-- </span> -->
                    <div class="progress-section">
                      <div class="progress-bar green">
                        <span class="inner-value">{{ one?.target }}</span>
                        @if (getPercent(one?.current_achieved, one?.eventData?.target) != '0') {
                          <div
                        class="progress green" [ngStyle]="{
                                                  'width.%': getPercent(one?.current_achieved, one?.eventData?.target) >= 100 ? 100 : (one?.current_achieved / one?.eventData?.target * 100),
                                background: 'linear-gradient(183.88deg,#0B8736 20.67%,#40EA7E 97.3%)'
                              }">
                            @if (one?.current_achieved != '0') {
                              <span
                                [ngClass]="getPercent(one?.current_achieved, one?.eventData?.target) == 100 ? 'percent-value-complete' : 'percent-value'">{{
                              one?.current_achieved }}</span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="img">
                      <img src="../../../../../../assets/icon/chestbox.svg" alt="">
                    </div>
                  </div>
                  @if (checkCards(one) == 'joinWithDisable') {
                    <div class="img">
                      <img [src]="mysteryBoxImgUrl" alt="champ" class="img-2" />
                    </div>
                  }
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        </ng-template>
      }
    </swiper>
    <div class="swiper-pagination"></div>
  </div>
  <div class="contributors-wrapper">
    <div class="titles-block">
      <div class="row">
        <h2>{{ "missions.Contributors" | translate }}</h2>
        @if (getRank(mission?.restData?.[selectedCard]?.leaderBoardData) !== null) {
          <div>
            <span class="current-rank">
              {{ "missions.ranking" | translate }}
              {{ getRank(mission?.restData?.[selectedCard]?.leaderBoardData) }}
            </span>
          </div>
        }
        @if (getRank(mission?.restData?.[selectedCard]?.leaderBoardData) === null) {
          <div>
            <span class="current-rank">
              {{ "missions.current_ranking" | translate }}
            </span>
          </div>
        }
      </div>
      <p class="desc">{{ "missions.Team_Challenge" | translate }} </p>
    </div>
    @if (!mission?.restData?.[selectedCard]?.leaderBoardData || !mission?.restData?.[selectedCard]?.leaderBoardData.length ) {
      <div class="contributors-empty-wrapper">
        <div class="empty-data">
          <img src="../../../../../../assets/icon/image-outline.svg" alt="">
          <p> {{ "missions.Contributors_yet" | translate }}
            <br>@if (checkCards(mission?.restData?.[selectedCard]) == 'join'&& !spinnerAnimation) {
              <a
                (click)="missionsDialog(); startSpinner()">{{
              "missions.the_Frist" | translate }}</a>
            }
            <!-- <br><a href="#">{{ "missions.the_Frist" | translate }}</a> -->
          </p>
        </div>
      </div>
    } @else {
      @for (list of mission?.restData?.[selectedCard]?.leaderBoardData; track list; let i = $index) {
        <div class="contributors-card-wrapper">
          <div class="card border-bottom" [ngClass]="i === 2 || i === 9 ? 'end-card' : ''">
            <div class="col-1">
              <div class="first-row">
                <div class="col-img">
                  <span>{{ i + 1 }}</span> <img src="{{ list?.profile_picture }}" alt="">
                </div>
                <div class="col-desc">
                  <h2>{{ list?.profile_nickname }}</h2>
                  <p> <img src="../../../../../../assets/icon/greengem.svg" alt="">
                    <span>{{ list?.fxp }} </span>&nbsp;
                    <!-- <span *ngIf="i < 3"> {{ "missions.Contribution" | translate}}</span> -->
                  </p>
                </div>
              </div>
            </div>
            <div class="col-2">
              @if (i < 3) {
                <img src="../../../../../../assets/icon/box1.svg" alt="">
              }
              @if (i >= 3) {
                <img src="../../../../../../assets/icon/box2.svg" alt="">
              }
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>
} @else {
  <app-in-progress-animation type="missions-cards-skeleton"></app-in-progress-animation>
}
